import DashboardWelcome, { DashboardQuickLinks } from "components/PortalDashboard";
import DashboardReports from "components/PortalDashboard/DashboardReports";
import RevenueReport from "admin/AdminDashboard2/RevenueReport";
import Admin2 from "layouts/Admin2";
import AggregateBooks from "./AggregateBooks";
import WeeklyRegistrationsGraph from "./WeeklyRegistrationsGraph";
import useAuthStore from "store/authStore";
import { Permission } from "utils/server-constants/permissions";
import AggregateRegistrations from "./AggregateRegistrations";
import ReadReport from "./ReadReport";
import BookMetricsExportPanel from "./Reports/BookMetricsExportPanel";

const AdminDashboard2 = () => {
	const { hasPermissions } = useAuthStore();

	return (
		<Admin2>
			<div className="portal-dashboard">
                <DashboardWelcome variant="admin" />
                <DashboardReports className="portal-dashboard-overview">
                    <AggregateBooks />
                    <AggregateRegistrations />
                </DashboardReports>
                <DashboardReports>
                    {hasPermissions([Permission.ViewLibRevenue]) && <RevenueReport />}
                    <WeeklyRegistrationsGraph />
                </DashboardReports>
                <ReadReport />
                <DashboardQuickLinks />
				{hasPermissions([Permission.ViewBooks, Permission.ViewBook]) && <BookMetricsExportPanel />}
			</div>
		</Admin2>
	);
};

export default AdminDashboard2;
